import { useState, useEffect } from 'react';
import {ShieldIcon,CloseIcon} from '../Icons/icons'
import '../Veilleur/veilleur.css';

function MobileDrawer({ open, onClose, children }) {
  /* Bloquer le scroll du body quand le drawer est ouvert */
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  return (
    <>
      {/* Backdrop (toujours dans le DOM pour la transition) */}
      <div
        className={`vv-drawer-backdrop${open ? ' open' : ''}`}
        onClick={onClose}
      />

      {/* Panel latéral */}
      <div className={`vv-drawer${open ? ' open' : ''}`}>
        {/* Header du drawer */}
        <div className="vv-drawer-header">
          <div className="vv-logo" style={{ fontSize: '0.95rem' }}>
            <ShieldIcon />
            PARK<span style={{ color: 'var(--pg-blue)' }}>GUARD</span>
          </div>
          <button className="vv-drawer-close" onClick={onClose} aria-label="Fermer le menu">
            <CloseIcon />
          </button>
        </div>

        {/* Contenu (même que sidebar desktop) */}
        <div className="vv-drawer-body">
          {children}
        </div>
      </div>
    </>
  );
}
export default MobileDrawer